export interface ParsedWikiContent {
  title?: string;
  content: string;
}

const stripGitlabImageMetadata = (content: string): string => {
  return content
    .replace(/(?!^)\s*\{[^{}\n]*(?:width|height)\s*=\s*[^{}\n]+[^{}\n]*\}(?=\s*(?:\n|$))/gim, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

// GitLab's wiki API always derives `title` from the page slug/filename - it
// never reads a `title:` frontmatter block inside the content, and it never
// strips that block out either. Pages that want a localized/overridden title
// (e.g. a German translation sharing the same filename as its English
// counterpart) rely on this client-side parse instead.
export const parseWikiFrontmatter = (content: string): ParsedWikiContent => {
  const frontmatterMatch = /^---\s*([\s\S]*?)\s*---\s*/.exec(content);

  if (!frontmatterMatch) {
    return { content: stripGitlabImageMetadata(content) };
  }

  const frontmatter = frontmatterMatch[1] ?? '';
  const titleMatch = /(?:^|\n)\s*title:\s*(.+?)\s*(?:\n|$)/i.exec(frontmatter);
  const parsedTitle = titleMatch?.[1]?.trim().replace(/^['"]|['"]$/g, '');
  const normalizedContent = stripGitlabImageMetadata(
    content.slice(frontmatterMatch[0].length).trimStart()
  );

  if (!parsedTitle) {
    return { content: normalizedContent };
  }

  return {
    title: parsedTitle,
    content: normalizedContent,
  };
};
